<template>
  <v-form ref="form" v-model="isValid">
    <v-row no-gutters align="center" justify="center" class="pt-1 pb-1">
      <v-col cols="1" class="text-center">
        <v-icon size="20" color="rgba(0, 0, 0, 0.7)">
          {{ getDataSourceIcon('linestring') }}
        </v-icon>
      </v-col>
      <v-col cols="5" class="pr-3">
        <data-input :value="value.length" @input="onInput('length', $event)" v-bind="lengthBind" />
      </v-col>
      <v-col cols="5" class="pr-3">
        <data-input :value="value.azimuth" @input="onInput('azimuth', $event)" v-bind="azimuthBind" />
      </v-col>
      <v-col cols="1" class="text-center">
        <v-tooltip bottom color="font" v-if="hasDelete">
          <template #activator="{ on }">
            <span v-on="on" class="d-flex justify-center">
              <v-icon size="20" color="error" @click="deleteAction">
                mdi-close
              </v-icon>
            </span>
          </template>
          {{ $i18n.t('sidebar.preciseDigitizing.deleteLineTooltip') }}
        </v-tooltip>
        <v-tooltip bottom color="font" v-if="hasAdd" :disabled="!isValid">
          <template #activator="{ on }">
            <span v-on="on" class="d-flex justify-center">
              <v-icon size="20" color="success" @click="addAction" :disabled="!isValid">
                mdi-check
              </v-icon>
            </span>
          </template>
          {{ $i18n.t('sidebar.preciseDigitizing.addLineTooltip') }}
        </v-tooltip>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import DataInput from '@/components/DataInput';
import stylePreviewUtilities from '@/mixins/stylePreviewUtilities';
export default {
  name: 'PreciseDigitizingSummaryLine',
  components: { DataInput },
  mixins: [stylePreviewUtilities],
  props: {
    value: {
      type: Object,
      required: true,
    },
    hasAdd: {
      type: Boolean,
      default: false,
    },
    hasDelete: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    lengthBind() {
      return {
        dataType: { name: 'decimal', decimal_places: 3 },
        hideDetails: true,
        label: this.$i18n.t('sidebar.preciseDigitizing.length'),
        persistentPlaceholder: true,
        allowNegative: false,
        rules: [v => (!!v && v > 0) || ''],
      };
    },
    azimuthBind() {
      return {
        dataType: { name: 'decimal', decimal_places: 2 },
        hideDetails: true,
        label: this.$i18n.t('sidebar.preciseDigitizing.azimuth'),
        persistentPlaceholder: true,
        rules: [v => ((!!v || v === 0) && v >= 0 && v <= 360) || ''],
      };
    },
  },
  data: () => ({
    isValid: false,
  }),
  methods: {
    onInput(name, value) {
      this.$set(this.value, name, value);
      this.$emit('input', { value: this.value, isValid: this[`${name}Bind`].rules.every(rule => rule(value)) });
    },
    addAction() {
      this.$emit('add', this.value);
    },
    deleteAction() {
      this.$emit('delete');
    },
  },
  watch: {
    value(nV, oV) {
      if (((oV.azimuth && oV.length) || (!oV.azimuth && !oV.azimuth)) && !nV.azimuth && !nV.length) {
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table__empty-wrapper {
    display: none;
  }
  .v-input__slot {
    min-height: 30px !important;
    font-size: 12px !important;
  }
  td {
    font-size: 12px !important;
  }
  .v-data-table__wrapper {
    max-height: calc(100vh - 400px);
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
